import { render, staticRenderFns } from "./OrganizationActivityCell.vue?vue&type=template&id=1c4f8ed1&scoped=true&"
import script from "./OrganizationActivityCell.vue?vue&type=script&lang=js&"
export * from "./OrganizationActivityCell.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationActivityCell.vue?vue&type=style&index=0&id=1c4f8ed1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4f8ed1",
  null
  
)

export default component.exports